import {IValueProps} from "./types";

export enum ChannelTypes {
  BROADCASTER = 'broadcaster',
  STREAMING_SERVICE = 'streaming_service'
}

export const getChannelOutLink = (channelOutFolder: string | null, channelId: number): string => {
  if (channelOutFolder === null)
    return '';
  return `${window.location.origin}/${channelOutFolder}/${channelId}`;
}

export const getValuePropsFromJson = (rawJson: string):IValueProps  => {
  return JSON.parse(rawJson)
}
